<script>
    import Header from "../header.svelte";
    import Button from "@smui/button/styled";
    import Textfield from "@smui/textfield/styled";
    import {
        api_host,
        user_store,
        domain_code_store,
        bpm_domain,
        recaptcha_key
    } from "../../stores";
    import { doFetch } from "../../utils/Fetching.js";
    import { onMount } from "svelte";
    import { google_user } from "../../utils/auth.js";
    import { toast_message } from "../../utils/toast_message.js";
    import { push, querystring } from "svelte-spa-router";

    let domain_code = "";
    domain_code_store.subscribe((value) => {
        domain_code = value;
    });
    let redirect_code = {};
    let is_height_fit = true;
    let plan_type = undefined;
    export let is_busy = false;

    onMount(async () => {
        const params = new URLSearchParams($querystring);
        if (params.has("domain_name") && params.has("plan_type")) {
            plan_type = params.get("plan_type");
            redirect_code = {
                plan_type: params.get("plan_type"),
                subdomain: params.get("domain_name"),
            };
        } else {
            push("/");
        }
    });

    $: {
        if (plan_type) {
        user_store.update((prev) => {
            prev["plan_type"] = plan_type;
            return prev;
        });
        }
    }

    user_store.subscribe((value) => {
        if (value["is_authenticated"]) push("/");
    });

    let email = "";
    let password = "";
    let first_name = "";
    let last_name = "";
    let register_state = true;
    let is_button_disabled = false;
    $: button_title = register_state ? "Next" : "Send password reset email";
    let register_step = true;

    const register = async () => {
        if (register_step) {
            const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (!email.match(mailformat)) {
                toast_message(false, "Invalid email address", 3000);
                return;
            }
            const lowerCaseLetters = /[a-z]/g;
            const upperCaseLetters = /[A-Z]/g;
            const numbers = /[0-9]/g;
            const missing_msg = [];
            if (!password.match(lowerCaseLetters))
                missing_msg.push("A lowercase letter");
            if (!password.match(upperCaseLetters))
                missing_msg.push("A capital letter");
            if (!password.match(numbers)) missing_msg.push("A number");
            if (password.length < 6) missing_msg.push("Minimum 6 characters");
            if (missing_msg.length > 0) {
                const error_msg = "Password must contain:\n" + missing_msg.join("\n");
                toast_message(false, error_msg, 10000);
                return;
            }
            register_step = false;
            return;
        }
        if (first_name.length == 0 || last_name == 0) {
            toast_message(false, "Invalid name", 3000);
            return;
        }
        is_button_disabled = true;
        grecaptcha.ready(function() {
            grecaptcha.execute(recaptcha_key, { action: "submit" }).then( async function(t) {
                const res = await doFetch(
                    api_host + "/auth/register",
                    "POST",
                    {
                        username: `${domain_code}${email}`.toLowerCase(),
                        password: password,
                        password2: password,
                        email: email.toLowerCase(),
                        first_name: first_name,
                        last_name: last_name,
                        plan_type: redirect_code["plan_type"],
                        role: "landscaper",
                    },
                    { "Content-Type": "application/json", DomainCode: domain_code }
                );
                is_button_disabled = false;
                const { user, token } = res;
                if (token) {
                    localStorage.setItem("HoyToKenTy", "Token");
                    localStorage.setItem("HoyToKenTo", token);
                    localStorage.setItem("HoyDoMainCode", domain_code);
                    window.location.href = "/";
                } else {
                    toast_message(
                        false,
                        res[0] || res.non_field_errors || res.username || "Registration failed",
                        2000
                    );
                }
            });
        });
        
    };

    const backRegisterStep = () => {
        register_step = true;
    }

    function doRecaptcha() {
        const key = "6LczIjMgAAAAAA7Iat2xKfRAz7HLG5cHI-lno56y";
        grecaptcha.ready(function() {
        grecaptcha.execute(recaptcha_key, { action: "submit" }).then(function(t) {
            console.log(t);
        });
    });
  }
    </script>

    <Header title="New User Registration" bind:is_busy />

    <div
    style={is_height_fit ? "height: 100%;" : "height: 100%;overflow-y: scroll"}
    id="form_container"
    >
    <div class="formholder">
        {#if register_step}
        <div class="registerformholder">
            <div class="ff email">
            <Textfield
                required
                type="email"
                style="width: 100%;"
                helperLine$style="width: 100%;"
                variant="outlined"
                bind:value={email}
                label="Email Address"
                name="user[email]"
            ></Textfield>
            </div>
            <div class="ff password">
            <Textfield
                required
                type="password"
                style="width: 100%;"
                helperLine$style="width: 100%;"
                variant="outlined"
                bind:value={password}
                label="Password"
                name="user[password]"
            ></Textfield>
            </div>

            <div style="padding-left: 15px;color: #2f2f2f;">
            Password must contain:
            <ul>
                <li>Minimum 6 characters</li>
                <li>A lowercase letter</li>
                <li>A capital letter</li>
                <li>A number</li>
            </ul>
            </div>

            <div class="ff buttonbar">
            <Button
                variant="raised"
                class="button-shaped-round"
                on:click={() => register()}>{button_title}</Button
            >
            </div>

            <!-- <div class="ff buttonbar">
                        <Button variant="raised" class="button-shaped-round" style="background-color: #f3f3f3;text-transform: none;color: #111111!important;" disabled={is_button_disabled} on:click={() => {
                            is_button_disabled = true;
                            Promise.resolve(google_user.signin()).then(async (res) => {
                                const res_keys = Object.keys(res);
                                let access_token, id_token;
                                for (let i in res_keys) {
                                    console.log(i, res[res_keys[i]]);
                                    if (res[res_keys[i]].hasOwnProperty('access_token') && res[res_keys[i]].hasOwnProperty('id_token')) {
                                        const { access_token: at, id_token: it } = res[res_keys[i]];
                                        access_token = at;
                                        id_token = it;
                                        break;
                                    }
                                }
                                console.log(access_token, id_token);
                                const res_google_auth = await doFetch(
                                    `${api_host}/auth/social/google/register`,
                                    'POST',
                                    {
                                        access_token,
                                        code: 'google',
                                        id_token,
                                        role: 'landscaper',
                                        plan_type: redirect_code['plan_type'],
                                        domain_name: `${redirect_code['subdomain']}.${bpm_domain}`,
                                        provider: 1
                                    },
                                    { 'Content-Type': 'application/json', 'DomainCode': domain_code }
                                );
                                is_button_disabled = false;
                                const { access_token: google_token } = res_google_auth;
                                if (!google_token) {
                                    toast_message(false, res_google_auth.msg || 'Registration failed', 2000);
                                } else {
                                    localStorage.setItem('HoyToKenTy', 'Bearer');
                                    localStorage.setItem('HoyToKenTo', google_token);
                                    localStorage.setItem('HoyDoMainCode', domain_code);
                                    window.location.href = '/';
                                }
                            });
                        }}><img src="/img/Google-Icon.png" alt="google icon" width="22px">&nbsp;&nbsp;Next with Google</Button>
                    </div> -->

            {#if $google_user}
            <h1 style="display: none;">{$google_user.profile.name}</h1>
            {/if}
            <!-- <div class="exception">
                        <div class="ff signin">
                            <a on:click={() => window.location.href = '#/login'}>If you have an account? Sign In</a>
                        </div>
                    </div> -->
        </div>
        {:else}
        <div class="registerformholder">
            <div class="ff name">
            <Textfield
                required
                type="text"
                style="width: 100%;"
                helperLine$style="width: 100%;"
                variant="outlined"
                bind:value={first_name}
                label="First Name"
                name="user[first_name]"
            ></Textfield>
            </div>
            <div class="ff name">
            <Textfield
                required
                type="text"
                style="width: 100%;"
                helperLine$style="width: 100%;"
                variant="outlined"
                bind:value={last_name}
                label="Last name"
                name="user[last_name]"
            ></Textfield>
            </div>
            <div class="ff backbuttonbar">
                <Button
                    variant="raised"
                    class="button-shaped-round"
                    style="margin-right: 5px;"
                    on:click={() => backRegisterStep()}
                    disabled={is_button_disabled}>Back</Button
                >
                <Button
                    variant="raised"
                    class="button-shaped-round"
                    style="margin-left: 5px;"
                    on:click={() => register()}
                    disabled={is_button_disabled}>{button_title}</Button
                >
            </div>
        </div>
        {/if}
    </div>
    </div>

    <style>
    :global(._toastMsg) {
        white-space: pre-line;
    }
    /* globals */
    .ff {
        padding: 10px;
    }
    .formholder {
        width: 500px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
    }
    .name {
        display: flex;
        justify-content: space-between;
    }
    .registerformholder {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        gap: 10px;
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas:
        "pt pt"
        "em em"
        "pw pw"
        "rm rm"
        "bb bb"
        "fp su";
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .formholder {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
        }
        .registerformholder {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        gap: 10px;
        grid-template-columns: repeat(1, 1fr);
        grid-template-areas:
            "pt"
            "em"
            "pw"
            "rm"
            "bb"
            "fp"
            "su";
        }
    }
    .email {
        grid-area: em;
    }
    .password {
        grid-area: pw;
    }
    .buttonbar {
        grid-area: bb;
    }
    .backbuttonbar {
        display: flex;
        justify-content: space-between;
    }
    * :global(.mdc-button) {
        width: 100% !important;
        color: white !important;
    }
    * :global(a) {
        color: rgb(0, 179, 0) !important;
        cursor: pointer;
    }
</style>
